module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("c6X4y"))).then(() => module.bundle.root('5erN3'));